import type { ReactNode } from "react";
import { getCookie } from "shared/auth/utils/cookieUtils";
import {
  normalizeUserRole,
  type AppUserRole,
} from "shared/auth/constants/roles";

type RoleMatchProps = {
  allowedRoles: readonly AppUserRole[];
  children: ReactNode;
  fallback: ReactNode;
};

/**
 * Synchronous role gate using the `userRole` cookie (same source as RoleGuard).
 * Use inside an authenticated shell so token validity is already enforced by RoleGuard.
 */
export function RoleMatch({
  allowedRoles,
  children,
  fallback,
}: RoleMatchProps) {
  const role = normalizeUserRole(getCookie("userRole"));
  if (role && allowedRoles.includes(role)) {
    return <>{children}</>;
  }
  return <>{fallback}</>;
}
